export default __webpack_public_path__ + "static/media/auction-toggle.3004003f.jpg";